module.exports = __webpack_public_path__ + "media/images/woman-profile-1-ae261f49e29b8d66b47ac54632c9631c.jpeg";